import React, { useContext, useState, useEffect, useRef } from 'react'
import moment from 'moment'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import ProductCommonContext from '@/product/context/common/commonContext'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '@/product/common/components'
import { dateFormatFunction } from '@/custom/common/components'
import { useTranslation } from 'react-i18next'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@material-ui/core'
import Loaders from '@/product/components/molecules/Loaders'
import CustomCommonContext from '@/custom/context/common/commonContext'
import BaseActionPage from '@/product/components/species/dynamic/common/BaseActionPage'
import AlertContext from '@/product/context/alert/alertContext'
import SellerProductContext from '@/product/context/seller/product/productContext'
import TemplateContext from '../../../../product/context/seller/template/product/productContext'
import { useCustomMediaQuery } from '@/product/common/components'
import DynamicContext from '../../../../product/context/dynamic/dynamicContext'
import AuthContext from '@/product/context/auth/authContext'
const ProductFieldsView = (props) => {
    const sellerProductContext = useContext(SellerProductContext)
    const templateContext = useContext(TemplateContext)
    const alertContext = useContext(AlertContext)
    const { t } = useTranslation()
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext
    const isMobileView = useCustomMediaQuery('(width <= 1024px)')
    const {
        projectAction,
        getSingleProject,
        single_project,
        responseStatus: responseStatusSellerProduct,
    } = sellerProductContext
    const dynamicContext = useContext(DynamicContext)
    const { getDynamicTableValues, dynamicTableValue } = dynamicContext
    const { setSignupModal, alldata_all_dropdown } = useContext(CustomCommonContext)
    const { single_project: template_SingleValue, getSingleProject: template_GetSingleValue } =
        templateContext

    const { setAlert } = alertContext
    const data = props.data
    const toggleFullScreenPopup = props.function
    const [isLoading, setIsLoading] = useState(true)
    const [reload, setReload] = useState(false)
    const [buttonData, setButtonData] = useState([])

    const [mapDataValue, setMapDataValue] = useState([])
    const [arrayData, setArrayData] = useState([])
    const [charityData, setCharityData] = useState([])
    const [filterCharity, setFilterCharity] = useState({})
    const [resetMapData, setResetMapData] = useState(false)

    const [formikValues, setFormikValues] = useState({})
    const membership = props.membership
    const mapDataValueRef = useRef(mapDataValue)

    useEffect(() => {
        mapDataValueRef.current = mapDataValue
    })

    const handleMapDataValue = (childMapDataValue) => {
        setMapDataValue(childMapDataValue)
    }

    const [customValidation, setCustomValidation] = useState([])

    useEffect(() => {
        let customValidationTemp = {}
        customValidationTemp = {
            date_added: Yup.date('Please enter valid Date!')
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  value,
                                  global.defaultDateTimeFormat
                                      ? global.defaultDateTimeFormat
                                      : 'MM-DD-YYYY h:mm a',
                              ).toDate(),
                          )
                        : new Date(moment(value)),
                )
                .nullable()
                .typeError(t('Required!'))
                .required(t('Required!')),
            date_closed: Yup.date(t('Please enter valid Date!'))
                .transform((__, value) =>
                    value && typeof value === 'string'
                        ? new Date(
                              moment(
                                  value,
                                  global.defaultDateTimeFormat
                                      ? global.defaultDateTimeFormat
                                      : 'MM-DD-YYYY h:mm a',
                              ).toDate(),
                          )
                        : new Date(moment(value).subtract(1, 'minutes')),
                )
                .min(Yup.ref('date_added'), t('Should be greater than start Time'))
                .nullable()
                .typeError(t('Required!'))
                .required(t('Required!')),

            auction: Yup.boolean().when('buynow', {
                is: (e) => !e,
                then: Yup.boolean().oneOf([true], t('Enable Auction or Buy Now')),
                otherwise: Yup.boolean(),
            }),
            uploadimages: Yup.array().nullable(),
            buynow: Yup.boolean().when('auction', {
                is: (e) => !e,
                then: Yup.boolean().oneOf([true], 'Enable Auction or Buy Now'),
                otherwise: Yup.boolean(),
            }),
            sprice: Yup.number().when('auction', {
                is: true,

                then: Yup.number()
                    .moreThan(-1)
                    .min(10, 'The minimum start price is 10')
                    .nullable(true),
            }),
            rprice: Yup.number().when(['auction', 'sprice'], {
                is: (auction, sprice) => auction && sprice && sprice > 0,
                then: Yup.number()
                    .positive('Should be greater than 1')
                    .required('Required!')
                    .min(Yup.ref('sprice'), 'Should be equal or greater than the starting price'),
                otherwise: Yup.number(),
            }),
            bprice: Yup.number().when('buynow', {
                is: true,
                then: Yup.number()

                    .moreThan(-1)
                    .min(10, 'The minimum buynow price is 10')
                    .required(t('Required!'))
                    .when('auction', {
                        is: true,
                        then: Yup.number().moreThan(
                            Yup.ref('rprice'),
                            t('Should be greater than the reserve price'),
                        ),
                    }),
            }),
            dimension_length: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            dimension_width: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            dimension_height: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            dimension_unit: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            // meeting_duration: Yup.string()
            //     .positive('Meeting duration must be greater than 0')
            //     .nullable()
            //     .transform((value, originalValue) => {
            //         return originalValue === '' || originalValue == 0 ? null : value
            //     }),
            weight_value: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            weight_unit: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            origin_zip: Yup.string().when('shipping_enable', {
                is: true,
                then: Yup.string().required(t('Required!')),
            }),
            ...props.customValidation,
        }

        setCustomValidation(customValidationTemp)
    }, [props.fieldValue, props.customValidation])
    const [dateClose, setDateClose] = useState(false)

    useEffect(() => {
        if (mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            const regex = new RegExp('\\bd-none\\b', 'gi')
            tempMapData.map((mapValue) => {
                if (mapValue.name === 'date_closed') {
                    if (formikValues.standing_offer) {
                        mapValue.disabled = true
                        const dateAdded = moment(
                            formikValues.date_added,
                            global.defaultDateTimeFormat || 'MM-DD-YYYY h:mm a',
                        )
                        const oneYearLater = dateAdded.clone().add(1, 'years')
                        formikValues.date_closed = oneYearLater.format(
                            global.defaultDateTimeFormat || 'MM-DD-YYYY h:mm a',
                        )
                        setDateClose(true)
                    } else if (dateClose) {
                        mapValue.disabled = false
                        setDateClose(false)
                        const dateAdded = moment(
                            formikValues.date_added,
                            global.defaultDateTimeFormat || 'MM-DD-YYYY h:mm a',
                        )
                        const oneYearLater = dateAdded.clone().add(10, 'days')
                        formikValues.date_closed = oneYearLater.format(
                            global.defaultDateTimeFormat || 'MM-DD-YYYY h:mm a',
                        )
                    } else {
                        if (props.minEndDate) {
                            mapValue.minDate = formikValues.date_added
                                ? new Date(
                                      new Date(
                                          moment(
                                              formikValues.date_added,
                                              global.defaultDateTimeFormat
                                                  ? global.defaultDateTimeFormat
                                                  : 'MM-DD-YYYY h:mm a',
                                          ).format(),
                                      ).getTime() +
                                          86400000 * props.minEndDate,
                                  )
                                : new Date()
                        } else {
                            mapValue.minDate = dateTimeFormatFunction(
                                formikValues.date_added ? formikValues.date_added : null,
                            )
                        }
                        mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
                            formikValues.date_added ? formikValues.date_added : null,
                        )}`
                        mapValue.disablePast = true
                        if (props.maxEndDate) {
                            mapValue.maxDate = formikValues.date_added
                                ? new Date(
                                      new Date(
                                          moment(
                                              formikValues.date_added,
                                              global.defaultDateTimeFormat
                                                  ? global.defaultDateTimeFormat
                                                  : 'MM-DD-YYYY h:mm a',
                                          ).format(),
                                      ).getTime() +
                                          86400000 * props.maxEndDate,
                                  )
                                : new Date()
                        }
                    }
                } else if (mapValue.name === 'date_added') {
                    mapValue.disablePast = true
                }
                //  else if (mapValue.name === 'sprice') {
                //     mapValue.disabled = formikValues.auction ? false : true
                // } else if (mapValue.name === 'rprice') {
                //     mapValue.disabled = formikValues.auction ? false : true
                // }
                else if (mapValue.name === 'bprice') {
                    mapValue.disabled = formikValues.buynow ? false : true
                } else if (mapValue.name === 'dimension_length') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_width') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_height') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'dimension_unit') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'weight_value') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'weight_unit') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'origin_zip') {
                    mapValue.class = `${
                        formikValues.shipping_enable ? '' : 'd-none'
                    } col-sm-6 col-6`
                } else if (mapValue.name === 'auction') {
                    if (formikValues.standing_offer) {
                        mapValue.class = `${formikValues.standing_offer ? 'd-none' : ''} `
                        formikValues.auction = false
                    } else {
                        // mapValue.disabled = formikValues.auction ? false : true
                        mapValue.class = `${
                            formikValues.standing_offer ? 'd-none' : ''
                        }col-sm-5 col-12 `
                    }
                } else if (mapValue.name === 'rprice') {
                    if (formikValues.standing_offer) {
                        mapValue.class = `${formikValues.standing_offer ? 'd-none' : ''} `
                        formikValues.rprice = ''
                    } else {
                        mapValue.disabled = formikValues.auction ? false : true
                        mapValue.class = `${
                            formikValues.standing_offer ? 'd-none' : ''
                        }col-sm-3 col-12`
                    }
                    if (formikValues.rprice == '' && !formikValues.standing_offer) {
                        formikValues.rprice = 10
                    }
                } else if (mapValue.name === 'sprice') {
                    if (formikValues.standing_offer) {
                        mapValue.class = `${formikValues.standing_offer ? 'd-none' : ''} `
                        formikValues.sprice = ''
                    } else {
                        mapValue.disabled = formikValues.auction ? false : true
                        mapValue.class = `${
                            formikValues.standing_offer ? 'd-none' : ''
                        }col-sm-3 col-12 `
                    }
                    if (formikValues.sprice == '' && !formikValues.standing_offer) {
                        formikValues.sprice = 10
                    }
                } else if (mapValue.name === 'buynow') {
                    if (formikValues.standing_offer) {
                        mapValue.class = `${formikValues.standing_offer ? 'd-none' : ''} `
                        formikValues.buynow = true
                    } else {
                        // mapValue.disabled = formikValues.auction ? false : true
                        mapValue.class = `${
                            formikValues.standing_offer ? 'd-none' : ''
                        }col-sm-5 col-12`
                        // formikValues.buynow = false
                    }
                }
                if (mapValue.name === 'meeting_datetime') {
                    if (formikValues.standing_offer) {
                        mapValue.disabled = true
                    } else {
                        mapValue.disabled = false
                        mapValue.minDate = formikValues.date_closed
                            ? new Date(
                                  new Date(
                                      moment(
                                          formikValues.date_closed,
                                          global.defaultDateTimeFormat
                                              ? global.defaultDateTimeFormat
                                              : 'MM-DD-YYYY h:mm a',
                                      ).format(),
                                  ).getTime() +
                                      86400000 * 1,
                              )
                            : new Date()
                        mapValue.minDateMessage = `Date should not be before minimal date ${dateTimeFormatFunction(
                            formikValues.date_closed ? formikValues.date_closed : null,
                        )}`
                        mapValue.disablePast = true
                    }
                }
                if (mapValue.name === 'registration_year') {
                    let val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.manufacturing_year,
                    )
                    val = parseInt(val[0]?.description)
                    let regArr = alldata_all_dropdown
                        .filter(
                            (value) => value.variable === 'registration_year' && value.level === 0,
                        )
                        .sort((a, b) => a.show_order - b.show_order)
                        .map((item) => {
                            let valueChanged = {}
                            valueChanged.show = parseInt(item.description)
                            valueChanged.value = data.diff_value ? item.value : item.id
                            return valueChanged
                        })
                    regArr = regArr.filter((e) => e.show >= val)
                    mapValue.options = regArr
                }
                if (mapValue.name === 'vehculo_nacionalpdf') {
                    const val = alldata_all_dropdown.filter((e) => e.id == formikValues.accidents)
                    if (val[0]?.description == 'Si') {
                        mapValue.class = 'col-sm-3 col-12'
                        mapValue.disabled = false
                    } else {
                        if (isMobileView) mapValue.class = 'col-sm-3 col-12 d-none'
                        else mapValue.class = 'col-sm-3 col-12 invisible'
                        mapValue.disabled = true
                    }
                }
                if (mapValue.name === 'maintanace_historypdf') {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.maintenance_historysino,
                    )
                    mapValue.class = `${
                        val[0]?.description == 'Si' ? '' : 'disabledDropzone d-none'
                    } col-sm-3 col-12`
                }
                if (props.toggleAuctionAndBuynow) {
                    const val = alldata_all_dropdown.filter(
                        (e) => e.id == formikValues.select_product_type,
                    )
                    if (mapValue.name === 'auction') {
                        mapValue.disabled = formikValues.buynow ? true : false
                    } else if (mapValue.name === 'buynow') {
                        mapValue.disabled = formikValues.auction ? true : false
                    }
                    if (mapValue.name === 'sprice') {
                        mapValue.class = mapValue.class.replace(regex, '')
                        if (formikValues.select_product_type != 1) {
                            if (val[0]?.description == 'Habilitar Subasta') {
                                formikValues.auction = 1
                                mapValue.class = `${mapValue.class}`
                                mapValue.disabled = false
                            } else {
                                formikValues.auction = 0
                                mapValue.class = `${'d-none '} ${mapValue.class}`
                                mapValue.disabled = true
                            }
                        }
                    }
                    if (mapValue.name === 'rprice') {
                        mapValue.class = mapValue.class.replace(regex, '')
                        if (formikValues.select_product_type != 1) {
                            if (val[0]?.description == 'Habilitar Subasta') {
                                formikValues.auction = 1
                                mapValue.disabled = false
                                mapValue.class = `${mapValue.class}`
                            } else {
                                formikValues.auction = 0
                                mapValue.disabled = true
                                mapValue.class = `${'d-none '} ${mapValue.class}`
                            }
                        }
                        // formikValues.rprice = formikValues.buynow ? '' : formikValues.rprice
                    }
                    if (mapValue.name === 'bprice') {
                        mapValue.class = mapValue.class.replace(regex, '')
                        if (formikValues.select_product_type != 1) {
                            if (val[0]?.description == 'Habilitar Venta directa') {
                                formikValues.buynow = 1
                                mapValue.class = `${mapValue.class}`
                                mapValue.disabled = false
                            } else {
                                formikValues.buynow = 0
                                mapValue.disabled = true
                                mapValue.class = `${'d-none '} ${mapValue.class}`
                            }
                        }
                        // formikValues.bprice = formikValues.auction ? '' : formikValues.bprice
                    }
                    if (mapValue.name == 'tire_manufacturer_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire,
                        )
                        mapValue.disabled = val[0]?.description == 'Si' ? false : true
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'd-none'
                        } col-sm-3 col-12`
                    }
                    if (mapValue.name == 'tire_size_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire,
                        )
                        mapValue.disabled = val[0]?.description == 'Si' ? false : true
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'd-none'
                        } col-sm-3 col-12`
                    }
                    if (mapValue.name == 'tire_image_spare') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire,
                        )
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'disabledDropzone d-none'
                        } col-sm-3 col-12`
                    }
                    if (mapValue.name == 'space_filler_1') {
                        const val = alldata_all_dropdown.filter(
                            (e) => e.id == formikValues.spare_tire,
                        )
                        mapValue.class = `${
                            val[0]?.description == 'Si' ? '' : 'disabledDropzone d-none'
                        } col-sm-3 col-12`
                    }
                }

                // if (mapValue.child) {
                //     let tempClass = mapValue.class.replace('d-none', '')
                //     mapValue.class = ` ${tempClass} ${
                //         formikValues[mapValue.parent_element] ? '' : 'd-none'
                //     }`
                // }
            })
            if (formikValues?.charity_id && formikValues.charity_id !== '') {
                let data = charityData?.filter(
                    (item) => item.fundraiser_id == formikValues?.charity_id,
                )

                if (data.length) {
                    console.log(data[0], 'alldatafundd======')
                    setFilterCharity(data[0])
                } else {
                    setFilterCharity({})
                }
            }
            setReload(!reload)
            // setMapDataValue(tempMapData)
            // setResetMapData(true)
        }
    }, [formikValues, charityData])

    useEffect(() => {
        if (dynamicTableValue && mapDataValueRef.current.length) {
            let tempMapData = mapDataValueRef.current
            if (dynamicTableValue.from === 'charity_data') {
                if (dynamicTableValue.records.length) {
                    setCharityData(dynamicTableValue.records)
                    tempMapData.map((mapValue) => {
                        if (mapValue.name === 'charity_id') {
                            mapValue.options = dynamicTableValue.records.map((data) => {
                                let busCategoryChanged = {}
                                busCategoryChanged.show = `${data.fundraiser_name},
                                    ${data.reg_number}`
                                busCategoryChanged.value = data.fundraiser_id
                                return busCategoryChanged
                            })
                        }
                    })
                } else {
                    setCharityData([])
                    tempMapData.map((mapValue) => {
                        if (mapValue.name === 'charity_id') {
                            mapValue.options = []
                        }
                    })
                }
            }
            setReload(!reload)
        }
    }, [dynamicTableValue])

    const additionalFormikUpdate = (data) => {
        console.log('kkkkkkkk', data)
        if (props.additionalFormikUpdate) {
            props.additionalFormikUpdate(data)
        }
        setFormikValues(data)
    }

    const submitFunction = (values, data) => {
        setIsLoading(true)
        const value = values
        if (value?.pre_market_status === 'preview') {
            // setFormikValues({
            //     ...formikValues,
            //     pre_market_status: '',
            // })
            props.previewFunction()
            setIsLoading(false)
        } else {
            if (data.status === 'new') {
                value.id = 0
            }
            if (data && data?.status === 'duplicate') {
                value.id = 0
                value.market_status = 'draft'
            }

            if (value.reverseauction) {
                value.auctiontype = 'reverse'
            }
            if (value.slot_date) {
                value.slot_date = dateFormatFunction(value.slot_date)
            }
            if (props.dynamicFieldTable) {
                value.table = props.dynamicFieldTable
            }
            if (props.checkMembership && data.status != 'edit') {
                if (value.auction) {
                    if (props.user.membership_period == 'yearly') {
                        if (props.membership?.auctions_year <= props.activeAuctionCount) {
                            setAlert('Auction membership limit was Exceed', 'error')
                            setIsLoading(false)
                            return false
                        }
                    } else {
                        if (props.membership?.monthly_auction <= props.activeAuctionCount) {
                            setAlert('Auction membership limit was Exceed', 'error')
                            setIsLoading(false)
                            return false
                        }
                    }
                }
                if (value.buynow) {
                    if (props.user.membership_period == 'yearly') {
                        if (props.membership?.users_limit_to <= props.activeBuynowCount) {
                            setAlert('Direct Sale Membership limit was Exceed', 'error')
                            setIsLoading(false)
                            return false
                        }
                    } else {
                        if (props.membership?.monthly_lots <= props.activeBuynowCount) {
                            setAlert('Direct Sale Lots Membership limit was Exceed', 'error')
                            setIsLoading(false)
                            return false
                        }
                    }
                }
                // if (props.customPopup) {
                //     setProductVal(value)
                //     setToggleDialog(true)
                //     setIsLoading(false)
                //     return false
                // }
            }
            if (props.toggleAuctionAndBuynow) {
                if (value.auction) {
                    value.bprice = ''
                } else {
                    value.sprice = ''
                    value.rprice = ''
                }
            }
            console.log('membership====>', props, charityData)
            if (Object.keys(filterCharity).length) {
                value.charity_name = filterCharity.fundraiser_name
            }
            if (
                value.uploadimages &&
                value.uploadimages.length <= 0 &&
                user &&
                user.profile_image
            ) {
                value.uploadimages = [
                    `${process.env.REACT_APP_DOMAIN}/uploads/useravatar/${user.profile_image}`,
                ]
            }
            projectAction(value)
        }
    }

    const formSubmit = (value, data) => {
        setFormikValues({
            ...formikValues,
            market_status: data,
        })
        // if (props.listingWithoutRegister) {
        //     if (props.user) {
        //         submitFunction()
        //     } else {
        //         setSignupModal(true, true)
        //     }
        // } else {
        submitFunction(value, data)
        setCharityData([])
        setFilterCharity([])

        // }
    }

    const cancelSubmit = () => {
        setIsLoading(false)
        setCharityData([])
        setFilterCharity([])
        toggleFullScreenPopup(false, 'new', 0)
        if (props.onFormBack) props.onFormBack()
    }

    useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
        if (data.status !== 'edit') {
            if (data.status === 'new') {
                setFormikValues({
                    ...formikValues,
                    id: 0,
                })
            }
        }
    }, [data.id])
    useEffect(() => {
        let mapData = props.fieldValue
        if (props.data.status === 'new') {
            setArrayData(mapData)
        } else {
            mapData.push({ name: 'wprice', value: '', type: 'default', active: 1 })
            setArrayData(mapData)
        }
    }, [props.data, props.fieldValue])
    useEffect(() => {
        const buttonDataTemp = []
        if (data && data?.status === 'duplicate') {
            buttonDataTemp.push({
                type: 'submit',
                style: 'primary',
                label: t('Duplicate'),
                additionalValue: 'open',
            })
        } else {
            if (formikValues.id) {
                if (props.enablePreview) {
                    buttonDataTemp.push({
                        type: 'button',
                        style: 'secondary',
                        label: t('PREVIEW'),
                        additionalValue: 'preview',
                        additionalField: 'pre_market_status',
                    })
                }
                if (formikValues.market_status === 'draft') {
                    buttonDataTemp.push({
                        type: 'button',
                        style: 'secondary',
                        label: t('SAVE AS DRAFT'),
                        additionalValue: 'draft',
                    })
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: props.SubmitBtnLabel ? props.SubmitBtnLabel : t('submit'),
                        additionalValue: 'open',
                    })
                }
                if (data.status === 'edit' && formikValues.market_status === 'open') {
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: props.SubmitBtnLabel ? props.SubmitBtnLabel : t('UPDATE'),
                        additionalValue: 'open',
                    })
                }
                if (data.status === 'use') {
                    buttonDataTemp.push({
                        type: 'button',
                        style: 'secondary',
                        label: t('SAVE AS DRAFT'),
                        additionalValue: 'draft',
                    })
                    buttonDataTemp.push({
                        type: 'submit',
                        style: 'primary',
                        label: t('submit'),
                        additionalValue: 'open',
                    })
                }
            } else {
                if (props.enablePreview) {
                    buttonDataTemp.push({
                        type: 'button',
                        style: 'secondary',
                        label: t('PREVIEW'),
                        additionalValue: 'preview',
                        additionalField: 'pre_market_status',
                    })
                }

                if (props.draftBtnActive) {
                    buttonDataTemp.push({
                        type: 'button',
                        style: 'secondary',
                        label: t('SAVE AS DRAFT'),
                        additionalValue: 'draft',
                    })
                }
                buttonDataTemp.push({
                    type: 'submit',
                    style: 'primary',
                    label: props.SubmitBtnLabel ? props.SubmitBtnLabel : t('submit'),
                    additionalValue: 'open',
                })
            }
        }
        setButtonData(buttonDataTemp)
    }, [formikValues.id, formikValues.market_status])

    useEffect(() => {
        if (responseStatusSellerProduct) {
            if (responseStatusSellerProduct.status === 'success') {
                setIsLoading(false)
                if (props.FullScreenPopup) toggleFullScreenPopup(false, '', 0)
                if (props.onSuccess) props.onSuccess()
            } else {
                setIsLoading(false)
            }
        }
    }, [responseStatusSellerProduct])

    return (
        <>
            {props.FullScreenPopup ? (
                <FullScreenPopup
                    modaltitle={
                        data.status === 'new'
                            ? props.addModaltitle
                                ? props.addModaltitle
                                : 'ADD NEW LISTING'
                            : data?.status === 'duplicate'
                            ? t('Edit Duplicate Lot')
                            : props.editModaltitle
                            ? props.editModaltitle
                            : `Edit Listing`
                    }
                    open={
                        data.status === 'new' ||
                        data.status === 'edit' ||
                        data.status === 'use' ||
                        data.status === 'duplicate'
                            ? data.popup
                            : false
                    }
                    handleClose={() => {
                        setCharityData([])
                        setFilterCharity([])
                        setIsLoading(false), toggleFullScreenPopup(false, 'new', 0)
                    }}
                >
                    <div className="productFullscreenModal customContainer">
                        <div className="fspBody">
                            {isLoading ? (
                                <div className="fspLoader noGridLoader">
                                    <Loaders isLoading={isLoading} />
                                </div>
                            ) : (
                                <>
                                    <BaseActionPage
                                        arrayValue={arrayData}
                                        customInitialValues={props.customInitialValues}
                                        data={props.data}
                                        additionalFormikUpdate={additionalFormikUpdate}
                                        editFunction={getSingleProject}
                                        editValue={single_project}
                                        populateValidation={props.populateValidation}
                                        handleMapDataValue={handleMapDataValue}
                                        actionFunction={formSubmit}
                                        cancelFunction={cancelSubmit}
                                        buttonAction={buttonData}
                                        customValidation={customValidation}
                                        BackBtnLabel={props.BackBtnLabel}
                                        backBtnDisabled={props.backBtnDisabled}
                                        template_SingleValue={template_SingleValue}
                                        template_GetSingleValue={template_GetSingleValue}
                                        customDynamicInput={
                                            props.customDynamicInput
                                                ? props.customDynamicInput
                                                : false
                                        }
                                        customInBetween={props.customInBetween}
                                        dynamicFieldTable={props.dynamicFieldTable}
                                        isDelete={props.isDelete}
                                        cancelpopup={props.cancelpopup ? props.cancelpopup : false}
                                        listingWithoutRegister={
                                            props.listingWithoutRegister && !props.user
                                                ? true
                                                : false
                                        }
                                        customPopup={props.customPopup}
                                        membership={membership}
                                        activeAuctionCount={props.activeAuctionCount}
                                        activeBuynowCount={props.activeBuynowCount}
                                        validationPopup={props.validationPopup}
                                        // mapDataValue={mapDataValue}
                                        // resetMapData={resetMapData}
                                        // setResetMapData={setResetMapData}
                                        customDescription={props.customDescription || null}
                                        customLocationFilter={props.customLocationFilter || null}
                                        filterCharity={filterCharity}
                                    />

                                    {/* </form> */}
                                </>
                            )}
                        </div>
                    </div>
                </FullScreenPopup>
            ) : (
                <div className="">
                    <div className="fspBody">
                        {isLoading ? (
                            <div className="fspLoader">
                                <Loaders isLoading={isLoading} />
                            </div>
                        ) : (
                            <>
                                <BaseActionPage
                                    arrayValue={arrayData}
                                    data={props.data}
                                    customInitialValues={props.customInitialValues}
                                    additionalFormikUpdate={additionalFormikUpdate}
                                    editFunction={getSingleProject}
                                    editValue={single_project}
                                    populateValidation={props.populateValidation}
                                    handleMapDataValue={handleMapDataValue}
                                    actionFunction={formSubmit}
                                    cancelFunction={cancelSubmit}
                                    buttonAction={buttonData}
                                    customValidation={customValidation}
                                    BackBtnLabel={props.BackBtnLabel}
                                    backBtnDisabled={props.backBtnDisabled}
                                    template_SingleValue={template_SingleValue}
                                    template_GetSingleValue={template_GetSingleValue}
                                    filterCharity={filterCharity}
                                    // mapDataValue={mapDataValue}
                                    // resetMapData={resetMapData}
                                    // setResetMapData={setResetMapData}
                                />

                                {/* </form> */}
                            </>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}

export default ProductFieldsView
